import { EAuthenticationActionType } from '../../actions/authentication';
import { EChatActionTypes } from '../../actions/chat';
import { IAppState, IChatState, TActions } from '../../common/state';

export const defaultState: IChatState = {
  offer: null,
  newbuildingContact: null,
  isOpened: false,
  position: null,
  openAfterAuth: false,
};

export function chatReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case EChatActionTypes.Open: {
      return {
        ...state,
        chat: {
          offer: action.payload.offer,
          newbuildingContact: null,
          isOpened: true,
          position: action.payload.position,
          openAfterAuth: false,
          isEarlyAccess: action.payload.isEarlyAccess,
          placeType: action.payload.placeType,
        },
      };
    }
    case EChatActionTypes.OpenChatbot: {
      return {
        ...state,
        chat: {
          offer: null,
          newbuildingContact: null,
          isOpened: true,
          position: null,
          openAfterAuth: false,
        },
      };
    }
    case EChatActionTypes.OpenNewbuildingChat: {
      return {
        ...state,
        chat: {
          offer: null,
          newbuildingContact: action.payload.newbuildingContact,
          isOpened: true,
          position: null,
          openAfterAuth: false,
          placeType: action.payload.placeType,
        },
      };
    }
    case EChatActionTypes.Close: {
      return {
        ...state,
        chat: defaultState,
      };
    }
    case EChatActionTypes.OpenAfterAuth:
      return {
        ...state,
        chat: {
          ...state.chat,
          offer: action.payload.offer,
          newbuildingContact: null,
          position: action.payload.position,
          openAfterAuth: true,
          placeType: action.payload.placeType,
        },
      };
    case EChatActionTypes.OpenNewbuildingChatAfterAuth:
      return {
        ...state,
        chat: {
          ...state.chat,
          offer: null,
          newbuildingContact: action.payload.newbuildingContact,
          position: null,
          openAfterAuth: true,
          placeType: action.payload.placeType,
        },
      };

    case EAuthenticationActionType.Succeed: {
      if (!state.chat.openAfterAuth) {
        return state;
      }

      return {
        ...state,
        chat: {
          ...state.chat,
          isOpened: true,
          openAfterAuth: false,
        },
      };
    }

    case EAuthenticationActionType.Cancelled:
      return {
        ...state,
        chat: {
          ...state.chat,
          openAfterAuth: false,
          placeType: undefined,
        },
      };
  }

  return state;
}
